export default "__VITE_ASSET__LNTVRP5L__"